module.exports = __webpack_public_path__ + "static/media/card-icon.ca1f07b7.svg";